import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { sanitizeUrl, Url } from '@wix/da-url';
import { BiData, DefaultBiEvent } from '@wix/da-bi/pkg/events';

import s from './CashbackBanner.scss';

const SMALL_COIN_IMG_SRC = Url.staticCDNLink(
  'eclipse/global/svg/cashback-da-coin-32.svg'
);
const LARGE_COIN_IMG_SRC = Url.staticCDNLink(
  'eclipse/global/images/cashback-da-coin-big.png'
);
const NARROW_BACKGROUND_STYLE = {
  style: {
    backgroundImage: `url(${Url.staticCDNLink(
      'eclipse/global/images/cashback-background.png?2'
    )})`,
  },
};

export interface Props {
  /** display the narrower (but taller) variant (for sidebar, mobile) */
  narrow?: boolean;
  className?: string;
}

const CashbackBanner: React.FC<Props> = ({ narrow: narrowProp, className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const narrow = narrowProp === undefined ? isMobile : narrowProp;
  const imageSource = narrow ? LARGE_COIN_IMG_SRC : SMALL_COIN_IMG_SRC;

  return (
    <PlainButtonOrLink
      className={c(s['root'], narrow ? s['narrow'] : s['wide'], className)}
      {...(narrow && NARROW_BACKGROUND_STYLE)}
      href={sanitizeUrl(t('cashbackBanner.linkHref'))}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'cashback_banner',
      })}
    >
      <div className={s['first']}>
        <img
          className={s['image']}
          src={imageSource}
          alt={t('cashbackBanner.a11y.imageAlt')}
        ></img>
        <span className={s['first-text']}>{t('cashbackBanner.firstline')}</span>
      </div>
      <span className={s['second']}>{t('cashbackBanner.secondline')}</span>
    </PlainButtonOrLink>
  );
};

CashbackBanner.displayName = 'CashbackBanner';
export default CashbackBanner;
